export const PAGES = {
  ACCOUNT: '/account',
  ADMIN: '/admin',
  AUTH: '/authentication',
  CHECKOUT: '/checkout',
  COMMUNICATION: '/communication',
  CUSTOMIZATION: '/customization',
  PAYSTATUS: '/paystatus',
  CATEG: '/categ',
  CATEG_LISTING: '/categListing',
  CATEG_WB: '/categWB',
  CATEG_CU: '/categCU',
  HOME: '/',
  LANDING_PAGE: '/landingPage',
  PRIMEUR: '/primeur',
  PRIMEUR_ALERT: '/primeur/search',
  PRIVATE_WEBSITE: '/privateWebsite',
  PRODUCT: '/product',
  SEARCH: '/search',
  BLOG: '/blog',
  BLOG_ARCHIVES: '/blog/archives',
  BLOG_HOME_URL: '/blog/index.html',
  CATEG_SPIRIT: '/spiritCateg',
  PRODUCT_SPIRIT: '/spiritProduct',
  PROFILE: '/profile',
  SPIRIT: '/spirits',
  CELLAR: '/cellar',
  CUSTOMER_LOYALTY: '/customerLoyalty',
  EXPRO: '/account/primeur-order',
  EXPRO_ORDER: '/primeur-checkout' as const,
  EXPRO_ORDER_REPORT: '/primeur-checkout/report' as const,
  WISHLIST: '/wishlist' as const,
  CONTACT: '/contact' as const
};

export const PRIMEUR_DEFAULT_LINK = `${PAGES.PRIMEUR}${PAGES.SEARCH}`;
